import React, { FC, useContext } from "react";
import { DEV_MODE } from "../../../scripts/devMode";
import { Settings } from "../../../scripts/settings";
import { SettingsContext } from "../../context/settings/SettingsLoader";
import { ViewType } from "../navigator/Navigator";

import './ViewSelector.scss';

const devMode = DEV_MODE;

interface props {
    currentView: ViewType,
    setter: React.Dispatch<React.SetStateAction<ViewType>>
}

interface buttonProps {
    type: ViewType,
    currentView: ViewType,
    setter: React.Dispatch<React.SetStateAction<ViewType>>
}
const SelectorButton: FC<buttonProps> = (props) => {
    const { children, type, currentView, setter } = props
    const set = () => { setter(type) }
    return <button onClick={set} aria-pressed={type === currentView}>
        {children}
    </button>
}

const ViewSelector: FC<props> = (props) => {
    const { currentView, setter } = props;


    const settings = useContext(SettingsContext);


    const showBook = !!(Settings.lookupSetting("Show Forbidden Book", settings));

    const showFKSection = showBook;

    return <div className="viewSelector serif">
        <SelectorButton currentView={currentView} type="SimpleWins" setter={setter} >Simple Wins</SelectorButton>
        <SelectorButton currentView={currentView} type="ScatterPlots" setter={setter} >Scatter Plots</SelectorButton>
        <SelectorButton currentView={currentView} type="TeamDetails" setter={setter} >Team Details</SelectorButton>
        <SelectorButton currentView={currentView} type="WinsOver500" setter={setter} >Wins over 0.500</SelectorButton>
        <SelectorButton currentView={currentView} type="FieldChart" setter={setter} >Field Positions</SelectorButton>
        <SelectorButton currentView={currentView} type="ModificationViewer" setter={setter} >Modifications</SelectorButton>
        <SelectorButton currentView={currentView} type="EventViewer" setter={setter} >Game Events</SelectorButton>
        <SelectorButton currentView={currentView} type="Settings" setter={setter} >Settings</SelectorButton>

        {
            showFKSection && <>
                <div className="divider" />
                {showBook && <SelectorButton currentView={currentView} type="ForbiddenBook" setter={setter} >Forbidden Book</SelectorButton>}
            </>
        }


        {
            devMode && <>
                <div className="divider" />
                <SelectorButton currentView={currentView} type="DevPage" setter={setter} >Developer Page</SelectorButton>
                <SelectorButton currentView={currentView} type="ElectionViewer" setter={setter} >Election Viewer</SelectorButton>
            </>
        }
    </div>
}

export default ViewSelector;